import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 40px; 
      height: 40px;
    }`
  }
`

const ChartStackedBarIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="65.729" height="68.16" isFromWidgetChoice={isFromWidgetChoice} viewBox="0 0 65.729 68.16">
      <path id="stacked_bar" d="M-10252.661-8117.84a1.216,1.216,0,0,1-1.219-1.215v-65.729a1.218,1.218,0,0,1,1.219-1.216h12.171a1.218,1.218,0,0,1,1.218,1.216v65.729a1.216,1.216,0,0,1-1.218,1.215Zm1.216-2.434h9.736v-21.641h-9.736Zm9.736-24.641v-18h-9.736v18Zm0-21v-17.651h-9.736v17.651Zm-27.993,48.075a1.216,1.216,0,0,1-1.218-1.215v-45.89a1.217,1.217,0,0,1,1.218-1.216h12.171a1.216,1.216,0,0,1,1.218,1.216v45.89a1.216,1.216,0,0,1-1.218,1.215Zm1.216-2.434h9.737v-11.643h-9.737Zm9.737-14.643v-14h-9.737v14Zm0-17v-11.812h-9.737v11.812Zm-27.993,34.076a1.216,1.216,0,0,1-1.219-1.215v-51.122a1.219,1.219,0,0,1,1.219-1.218h12.171a1.219,1.219,0,0,1,1.218,1.218v51.122a1.216,1.216,0,0,1-1.218,1.215Zm1.215-2.434h9.74v-4.642h-9.74Zm9.74-7.642v-23h-9.74v23Zm0-26v-15.044h-9.74v15.044Zm-28,36.075a1.216,1.216,0,0,1-1.218-1.215v-32.92a1.219,1.219,0,0,1,1.218-1.218h12.171a1.218,1.218,0,0,1,1.218,1.218v32.92a1.216,1.216,0,0,1-1.218,1.215Zm1.219-2.434h9.734v-10.642h-9.734Zm9.734-13.642v-8h-9.734v8Zm0-11v-5.845h-9.734v5.845Z" transform="translate(10305.001 8186)" fill="currentColor"/>
    </SVG>
  </IconContainer>
)

export default ChartStackedBarIcon